var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscovery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "19px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    fill: "#6b718e",
    stroke: "#6b718e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#6b718e",
    strokeWidth: 0.064
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .stone_een{fill:#131b23;} "), /*#__PURE__*/React.createElement("path", {
    className: "stone_een",
    d: "M13,21.5c0,3.038-2.462,5.5-5.5,5.5S2,24.538,2,21.5S4.462,16,7.5,16S13,18.462,13,21.5z M24.5,16 c-3.038,0-5.5,2.462-5.5,5.5s2.462,5.5,5.5,5.5s5.5-2.462,5.5-5.5S27.538,16,24.5,16z M32,21.5c0,4.142-3.358,7.5-7.5,7.5 c-3.441,0-6.333-2.32-7.216-5.478C16.935,23.816,16.491,24,16,24s-0.935-0.184-1.284-0.478C13.833,26.68,10.941,29,7.5,29 C3.358,29,0,25.642,0,21.5c0-1.195,0.287-2.321,0.784-3.323l3.515-8.453c0.468-1.372,1.464-2.496,2.743-3.139 C7.246,5.126,8.485,4,10,4c1.657,0,3,1.343,3,3c0,0.082-0.017,0.159-0.024,0.239C14.211,8.248,15,9.781,15,11.5 c0,0.225,0,0.491,0,0.777C15.295,12.106,15.634,12,16,12s0.705,0.106,1,0.277c0-0.286,0-0.552,0-0.777 c0-1.742,0.812-3.292,2.076-4.3c-0.008-0.066-0.02-0.132-0.02-0.2c0-1.657,1.343-3,3-3c1.523,0,2.768,1.139,2.961,2.61 c1.252,0.647,2.223,1.762,2.685,3.114l3.515,8.453C31.713,19.179,32,20.305,32,21.5z M14,21.5c0-3.59-2.91-6.5-6.5-6.5 S1,17.91,1,21.5S3.91,28,7.5,28S14,25.09,14,21.5z M17,22c0-0.552-0.448-1-1-1s-1,0.448-1,1c0,0.552,0.448,1,1,1S17,22.552,17,22z M31,21.5c0-3.59-2.91-6.5-6.5-6.5S18,17.91,18,21.5s2.91,6.5,6.5,6.5S31,25.09,31,21.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovery);
export default __webpack_public_path__ + "static/media/discovery.7c247648dd0ffe6bb396c3a61f0a9da7.svg";
export { ForwardRef as ReactComponent };